export default `
  mutation deleteGitHubRepo($login: String!, $owner: String!, $repo: String!) {
    deleteGitHubRepo(login: $login, owner: $owner, repo: $repo) {
      success
      resData
      errorText
    }
  }
`
